/* global axios */
import ApiClient from '../ApiClient';

class PricingRulesAPI extends ApiClient {
  constructor() {
    super('planning/pricing-plans', { accountScoped: true });
  }

  getAll(planId) {
    return axios.get(`${this.url}/${planId}/rules`);
  }

  get(planId, ruleId) {
    return axios.get(`${this.url}/${planId}/rules/${ruleId}`);
  }

  create(planId, payload) {
    return axios.post(`${this.url}/${planId}/rules`, {
      pricing_rule: payload,
    });
  }

  update(planId, ruleId, payload) {
    return axios.put(`${this.url}/${planId}/rules/${ruleId}`, {
      pricing_rule: payload,
    });
  }

  delete(planId, ruleId) {
    return axios.delete(`${this.url}/${planId}/rules/${ruleId}`);
  }
}

export default new PricingRulesAPI();
